export const GET_NOTIFICATIONS_FROM_PSYCHICS = 'customers/psychicnotifications/unread';
